import React from 'react';

import { useProduct } from '../../hooks/useProduct'
import * as constants from '../../constants'
import AbstractBestPracticeList from '../AbstractBestPracticeList'


export default function(props) {
  const productDetails = useProduct()
  return (
    <AbstractBestPracticeList
      category={constants.CATEGORY_TESTS}
      title={'Python testing best practice'}
      seoTitle={'Python testing best practice'}
      svgPath='/risk.svg'
      synopsis_parageaph_one={`${productDetails.name} suggests a fix if your code does not follows Python testing best practices.`}
      synopsis_parageaph_two='This gives you greater confidence in the quality of your tests because it is not what you test that is important, but how you test.'
    />
  );
}
